import '/Users/josiahayres/GitHub/storybook-addon-mantine/dist/manager.mjs';